(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[46],{

/***/ "zhEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Trident1", function() { return Trident1; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Trident1 = function Trident1(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 500"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M363.8 335.7l-51 51 51 51 51-51-51-51zm32.4-321.8c-2.3-11.6-30.1 4.7-90.3 57.9 23.1 25.4 34.7 11.6 55.5 4.7 16.2 27.8 20.9 159.7-78.7 199.1 2.3-131.9 4.7-273.2 4.7-273.2-2.3-2.3-4.7-2.3-7-2.3C252.7 4.7 204.1 51 167 92.6c20.9 34.7 46.3 2.3 67.2-4.7 0 4.7-4.7 101.8-2.3 201.4-101.9 7-85.7-201.3-81.1-226.8C153.1 39.4 86 87.9 51.3 118c11.6 18.5 25.4 16.2 44 9.2-7 92.6 57.9 178.2 136.6 175.9 2.3 97.3 13.9 189.8 41.7 196.8 4.7 0 7-97.3 9.2-208.3C465.7 236.1 396.2 13.9 396.2 13.9z"
  }));
};

/***/ })

}]);